module.exports = __webpack_public_path__ + "img/dark-s_px.f0e258ca.jpg";